module.exports = __webpack_public_path__ + "static/feature5-36e3066cc278f35e936d915117afc699.png";